import { registerMockAPI } from '~/mocks/mockApis';

import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetOutboundsParams, TypeGetOutboundsResponse } from '~/types/delivery-agency.types';

/**
 * [운송장 관리] 출고 단위 조회 API
 */
const fetchOutbounds = async (params: TypeGetOutboundsParams): Promise<TypeGetOutboundsResponse['data']> => {
  const { data } = await axiosInstance.get<TypeGetOutboundsResponse>(API_ENDPOINT.DELIVERY_AGENCY.GET_OUTBOUNDS, {
    params,
  });
  return data.data;
};

/**
 * [운송장 관리] 출고 단위 조회 Mutation Hook
 */
export const useGetOutboundsMutation = () => {
  return useMutation({
    mutationFn: fetchOutbounds,
  });
};

/**
 * [운송장 관리] 출고 단위 조회 Mock
 */
registerMockAPI<TypeGetOutboundsResponse>({
  method: 'get',
  endpoint: '/api-delivery-agency/outbounds',
  label: '운송장 관리/출고 단위 조회',
  scenarios: [
    {
      name: '생성 가능',
      response: {
        data: {
          outboundCode: '26617T0002272',
          isCreatableShippingLabel: true,
          shippingLabelNumbers: ['250-S0-26617T0002272-0001'],
          receiverName: '김보리',
          productName: '[에스티 로더] 갈색병 세럼 50ml 기획세트 1+1 사은품 증정',
        },
      },
    },
    {
      name: '생성 불가능',
      response: {
        data: {
          outboundCode: '26617T0002272',
          isCreatableShippingLabel: false,
          shippingLabelNumbers: ['250-S0-26617T0002272-0001'],
          receiverName: '김보리',
          productName: '[에스티 로더] 갈색병 세럼 50ml 기획세트 1+1 사은품 증정',
        },
      },
    },
    {
      name: '검색 결과 0건',
      response: { data: null },
    },
  ],
});
